import WatermarkOverlay from './WatermarkOverlay';

export default WatermarkOverlay;
